"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _carouselClasses = require("./carouselClasses");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Header = ({
  title,
  navigation,
  navigationArrows
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    text,
    maxLines,
    children,
    relativeUrl,
    component = 'h4',
    variant = 'h4'
  } = title ?? {};
  const shouldRenderTopArrows = navigation?.arrowsMode?.type === 'compact' && navigation.arrowsMode.position.includes('top');
  const shouldRenderHeader = !!text || shouldRenderTopArrows || Boolean(children);
  if (!shouldRenderHeader) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.HeaderContainer, {
    hasTitle: !!text || Boolean(children),
    className: _carouselClasses.carouselClasses.header,
    children: [!!text || Boolean(children) ? children ?? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.TitleContainer, {
      "data-testid": getTestId(_constants.TITLE_CONTAINER),
      as: relativeUrl ? 'a' : 'div',
      ...(relativeUrl && {
        href: relativeUrl
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
        component: component,
        variant: variant,
        color: "textPrimary",
        maxLines: maxLines,
        className: _carouselClasses.carouselClasses.title,
        children: text
      }), relativeUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        disabled: true,
        size: "medium",
        variant: "text",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {
          fontSize: "inherit",
          color: "default"
        })
      }) : null]
    }) : null, shouldRenderTopArrows ? navigationArrows : null]
  });
};
exports.Header = Header;
//# sourceMappingURL=Header.js.map